import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, LOCALE_ID, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtcToLocalDateTimePipe } from '@cms/shared-library';
import { TranslateService } from '@ngx-translate/core';
import { ClassCourseWithEnrolmentsDTO } from 'src/app/models/class-coursewithenrolments-dto.model';
import { ClassEnrolment, EnrolmentStatus } from 'src/app/models/class-enrolment.model';
import { CourseService } from 'src/app/services/course/course.service';
import { TrainingProgramService } from 'src/app/services/training-program/training-program.service';
import { formatAddress } from 'src/app/utils/address.util';
import { FormatUtil } from 'src/app/utils/format.util';
import { TrainingProgramApplicationUtils } from 'src/app/utils/training-program-application.util';

@Component({
    selector: 'app-enrolement-summary',
    templateUrl: './enrolement-summary.component.html',
    styleUrls: ['./enrolement-summary.component.scss'],
    standalone: false
})
export class EnrolementSummaryComponent implements OnInit {
  @Input() groupOrRegIdInput: string
  @Input() isTP = false
  @Input() status: string
  @Input() updatedPending = false
  @Input() updatedConfirmed = false

  @Output() learnerSelectedOutput: EventEmitter<string> = new EventEmitter<string>()
  @Output() enrolmentGroupId: EventEmitter<string> = new EventEmitter<string>()

  tpAppUtils = TrainingProgramApplicationUtils;
  formatUtil = FormatUtil;

  datePipe: DatePipe;
  utcDatePipe: UtcToLocalDateTimePipe;
  ENROLSTATUS = EnrolmentStatus;

  currentLang: string = 'en';
  groupOrRegId: string = '';

  classCourseWithEnrolmentsDTO: ClassCourseWithEnrolmentsDTO = new ClassCourseWithEnrolmentsDTO();
  primaryContact?: ClassEnrolment;
  Learners: ClassEnrolment[] = [];
  SubmittedDate: Date;
  CompletedDate: Date;
  enrolMentRequestType: string = '';
  enrolMentRequestFor: string = '';
  mainEmailAddress: string = '';

  isPageComponent: boolean = true
  totalLearnersReserved: number = 0
  isCompleted: boolean = false
  isWorker:boolean=false

  constructor(
    @Inject(LOCALE_ID) public locale: string,
    @Inject('CourseService') public courseService: CourseService,
    @Inject('TrainingProgramService') public trainingProgramService: TrainingProgramService, public translateService: TranslateService, public router: Router,
    public route: ActivatedRoute,
    public cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translateService.currentLang;
    this.datePipe = new DatePipe(this.currentLang == 'en' ? 'en-CA' : 'fr-CA')
    this.utcDatePipe = new UtcToLocalDateTimePipe()

    this.getCourseDetails();
    this.isPageComponent = this.groupOrRegIdInput == null || this.groupOrRegIdInput == undefined
    
    if (this.route.snapshot.queryParams['isWorker']) {
      this.isWorker = this.route.snapshot.queryParams['isWorker']
    }
  }

  getCourseDetails() {
    if (!this.isTP) {
      const enrolmentDetails = JSON.parse(sessionStorage.getItem('enrolmentDetails')?.toString()!);
      this.classCourseWithEnrolmentsDTO.courseDetails = JSON.parse(sessionStorage.getItem('course')?.toString()!);
      this.classCourseWithEnrolmentsDTO.CourseEnrolments = [];
      this.classCourseWithEnrolmentsDTO.CourseEnrolments = enrolmentDetails as ClassEnrolment[];
      this.Learners = [];
      this.Learners = enrolmentDetails as ClassEnrolment[];

      this.enrolMentRequestType = this.tpAppUtils.getCourseRequestTypeText(this.classCourseWithEnrolmentsDTO.CourseEnrolments[0].EnrolmentRequestType ?? '1');
      this.enrolMentRequestFor = this.tpAppUtils.getCourseRequestForText(this.classCourseWithEnrolmentsDTO.CourseEnrolments[0].EnrolmentRequestType ?? '1', 
          this.classCourseWithEnrolmentsDTO.CourseEnrolments[0].EnrolmentRequestFor ?? '1');

      if (this.enrolMentRequestType === 'ClassEnrolment.MultipleEnrolments' && this.Learners.length > 1) {
        this.primaryContact = this.classCourseWithEnrolmentsDTO.CourseEnrolments.find(a => a.IsPrimary);
      }

      if (this.primaryContact && !this.tpAppUtils.isNullOrEmpty(this.primaryContact.EmailAddress)) this.mainEmailAddress = this.primaryContact.EmailAddress;
      else if (this.Learners[0] && !this.tpAppUtils.isNullOrEmpty(this.Learners[0].EmailAddress)) this.mainEmailAddress = this.Learners[0].EmailAddress;
  
      if (this.primaryContact && !this.tpAppUtils.isNullOrEmpty(this.primaryContact.CreatedDate)) this.SubmittedDate = this.primaryContact.CreatedDate ?? new Date;
      else if (this.Learners[0] && !this.tpAppUtils.isNullOrEmpty(this.Learners[0].CreatedDate)) this.SubmittedDate = this.Learners[0].CreatedDate ?? new Date;
  
      if (this.primaryContact && !this.tpAppUtils.isNullOrEmpty(this.primaryContact.CompletedOn)) this.CompletedDate = this.primaryContact.CompletedOn ?? new Date;
      else if (this.Learners[0] && !this.tpAppUtils.isNullOrEmpty(this.Learners[0].CompletedOn)) this.CompletedDate = this.Learners[0].CompletedOn ?? new Date;
  
      this.totalLearnersReserved = this.Learners.length;
      if (this.primaryContact && this.enrolMentRequestType === 'ClassEnrolment.MultipleEnrolments') {
        this.totalLearnersReserved--;
      }

      if (this.Learners && this.Learners.length > 0) {
          this.isCompleted = this.Learners[0].EnrolmentStatus == this.ENROLSTATUS.EnrolmentStatusCompleted
      }
  
      if (this.classCourseWithEnrolmentsDTO.CourseEnrolments[0].EnrolmentGroupId != null) {
          this.enrolmentGroupId.emit(this.classCourseWithEnrolmentsDTO.CourseEnrolments[0].EnrolmentGroupId);
      }
    } else {
      this.groupOrRegId = sessionStorage.getItem('groupOrRegId')?.toString()!;
      if (!this.groupOrRegId) {
        this.groupOrRegId = this.route.snapshot.params['groupOrRegId'] ?? this.groupOrRegIdInput;
      }
      if (this.groupOrRegId) {
        this.courseService.GetEnrolmentDetailsByGroupIdOrRegistrationId(this.groupOrRegId).subscribe((data) => {
          if (data != null) {
            this.classCourseWithEnrolmentsDTO = data;
            this.primaryContact = data.CourseEnrolments.find(a => a.IsPrimary);

            if (['pending', 'cancelled'].indexOf(this.status) > -1) data.CourseEnrolments = data.CourseEnrolments.filter(x => x.EnrolmentStatus == (this.status == 'pending' ? EnrolmentStatus.EnrolmentStatusPending : EnrolmentStatus.EnrolmentStatusCanceled))
            this.Learners = data.CourseEnrolments.filter(a => !a.IsPrimary);
            this.enrolMentRequestType = this.tpAppUtils.getCourseRequestTypeText(this.classCourseWithEnrolmentsDTO.CourseEnrolments[0].EnrolmentRequestType ?? '1');
            this.enrolMentRequestFor = this.tpAppUtils.getCourseRequestForText(this.classCourseWithEnrolmentsDTO.CourseEnrolments[0].EnrolmentRequestType ?? '1', this.classCourseWithEnrolmentsDTO.CourseEnrolments[0].EnrolmentRequestFor ?? '1');

            if (this.primaryContact && !this.tpAppUtils.isNullOrEmpty(this.primaryContact.EmailAddress)) this.mainEmailAddress = this.primaryContact.EmailAddress;
            else if (this.Learners[0] && !this.tpAppUtils.isNullOrEmpty(this.Learners[0].EmailAddress)) this.mainEmailAddress = this.Learners[0].EmailAddress;

            if (this.primaryContact && !this.tpAppUtils.isNullOrEmpty(this.primaryContact.CreatedDate)) this.SubmittedDate = this.primaryContact.CreatedDate ?? new Date;
            else if (this.Learners[0] && !this.tpAppUtils.isNullOrEmpty(this.Learners[0].CreatedDate)) this.SubmittedDate = this.Learners[0].CreatedDate ?? new Date;

            if (this.primaryContact && !this.tpAppUtils.isNullOrEmpty(this.primaryContact.CompletedOn)) this.CompletedDate = this.primaryContact.CompletedOn ?? new Date;
            else if (this.Learners[0] && !this.tpAppUtils.isNullOrEmpty(this.Learners[0].CompletedOn)) this.CompletedDate = this.Learners[0].CompletedOn ?? new Date;

            this.totalLearnersReserved = this.Learners.length;
            if (this.Learners && this.Learners.length > 0) {
              this.isCompleted = this.Learners[0].EnrolmentStatus == this.ENROLSTATUS.EnrolmentStatusCompleted
            }

            if (this.classCourseWithEnrolmentsDTO.CourseEnrolments[0].EnrolmentGroupId != null) {
              this.enrolmentGroupId.emit(this.classCourseWithEnrolmentsDTO.CourseEnrolments[0].EnrolmentGroupId);
            }
          }
        });
      }
    }
    if ((!this.primaryContact && this.enrolMentRequestType === 'ClassEnrolment.SingleEnrolment' && this.enrolMentRequestFor === 'ClassEnrolment.TeamMember') ||
            (this.enrolMentRequestType === 'ClassEnrolment.MultipleEnrolments' && this.primaryContact) && this.Learners.length > 1) {
      this.FilterPrimaryContact();
    }
  }

  getTime(date) {
    let curDate = new Date(date.toString() + 'Z')

    let hour = this.datePipe.transform(curDate, 'h')
    let minutes = this.datePipe.transform(curDate, 'mm')
    let ampm = this.datePipe.transform(curDate, 'a')

    let time = hour
    if (minutes != '00') time += (':' + minutes)
    time += ' ' + ampm!.toLocaleLowerCase()
    return time
  }

  FilterPrimaryContact() {
    this.primaryContact = this.Learners.filter(a=>a.IsPrimary)?.[0];
    this.Learners = this.Learners.filter(a=>!a.IsPrimary);

  }

  getDate(date, format) {
    return this.datePipe.transform(date, format)
  }

  formatAddress() {
    if (this.classCourseWithEnrolmentsDTO && this.classCourseWithEnrolmentsDTO.courseDetails)
      return formatAddress(this.classCourseWithEnrolmentsDTO.courseDetails)
    else return ''
  }

  backToMarketplace() {
    if (this.isWorker) {
      this.router.navigate(['worker/training-schedules/course-search']);
    } else if (this.isTP) {
      this.router.navigate(['../../course-search'], { relativeTo: this.route });
    } else {
      // Public site
      const langPref = this.currentLang == 'fr' ? 'fr/' : '';
      this.router.navigate([`${langPref}safety-and-prevention/cpo-approved-courses`]);
    }
  }

  displaySelectLearnerCheckbox(): boolean {
    if (this.enrolMentRequestType === 'ClassEnrolment.SingleEnrolment') {
      return false;
    } else {
      return this.Learners.length > 0;
    }
  }

  isLearnersInfoInComplete(): boolean {
    if (this.isTP && this.Learners.length > 0) {
      const isLearnerInfoIncomplete = this.Learners.some(
        (enrollment) => !enrollment.FirstName || !enrollment.LastName || !enrollment.EmailAddress || !enrollment.Phone || !enrollment.BirthYear
      );
      return isLearnerInfoIncomplete;
    }

    return false;
  }

  getCPOApprovedCoursesURL() {
    return this.isWorker? (this.currentLang == 'en'?'/worker/training-schedules/course-search':'/fr/worker/training-schedules/course-search') :
      (this.currentLang == 'en'?'/safety-and-prevention/cpo-approved-courses':'/fr/safety-and-prevention/cpo-approved-courses')
  }
}
